import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { authService } from "@/services/auth-service";

/** True when the response says the session itself is gone, as opposed to a network blip or a 5xx. */
export function isSessionAuthError(error: unknown): boolean {
  const status = (error as { response?: { status?: number } } | null)?.response?.status;
  return status === 401 || status === 403;
}

/** React Query-cached session — always resolved by calling this app's own `/api/auth/me` route, which proxies through the server-side refresh logic. */
export function useSession(): UseQueryResult<User | null> {
  return useQuery<User | null>({
    queryKey: ["auth", "session"],
    queryFn: authService.me,
    // Retry blips (the network waking up with a backgrounded tab) but not a session that is really gone.
    retry: (failureCount, error) => failureCount < 2 && !isSessionAuthError(error),
    staleTime: 5 * 60 * 1000,
  });
}
